import { Spin } from 'antd';
import { createAnonymousSession, useSignedUser } from 'api/auth';
import { useGuestCartDetail, useGuestProductList, useGuestStoreDetails } from 'api/guest_sdk';
import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ERROR_EXPIRED_API } from 'utils/sdk';

export const GuestLoginGuard = ({ children }: { children: React.ReactNode }) => {
  const params = useParams<{ storeId: string }>();

  const storeId = useMemo(() => (params.storeId ? Number(params.storeId) : null), [params.storeId]);

  const { data: user, error, mutate: mutateUser, isLoading } = useSignedUser();

  const { mutate: mutateGuestCart } = useGuestCartDetail({
    storeId,
  });

  const { mutate: mutateStore } = useGuestStoreDetails({ storeId });
  const { mutate: mutateStoreList } = useGuestProductList({
    storeId,
  });

  useEffect(() => {
    if (error && error.message === ERROR_EXPIRED_API) {
      // Login the guest
      createAnonymousSession().then(() => {
        mutateUser();
        mutateStoreList();
        mutateGuestCart();
        mutateStore();
      });
    }
  }, [error, mutateUser, mutateStoreList, mutateGuestCart, mutateStore]);

  if (isLoading || !user) {
    return <Spin />;
  }

  return children;
};
